import { Link } from "@cloudscape-design/components"
export default () => {
    return (
        <footer className="pagefooter" role="navigation" aria-label="footer">
            <div className="">
                <div className="full-width-container">
                    <div className="footer-wrapper">
                        <ul>
                            <li>
                                <div>
                                    <Link href="https://aws.amazon.com/neptune">About</Link>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <Link href="https://aws.amazon.com/privacy" external={true} externalIconAriaLabel="(opens in new tab)">Privacy</Link>
                                </div>
                            </li>
                            <li>
                                <div>
                                    <Link href="https://aws.amazon.com/terms" external={true} externalIconAriaLabel="(opens in new tab)">Site Terms</Link>
                                </div>
                            </li>
                            <li>
                                <span className="footer-rights">© {new Date().getFullYear() }, Amazon Web Services, Inc. or its affiliates. All rights reserved.</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}